
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'BankCard',
  mixins: [staticBlockMixin],

  inject: [
    'globalFormProvider',
    'setGlobalFormProviderProperties'
  ],

  props: {
    productList: {
      type: Array,
      default: () => []
    }

  },

  data () {
    return {
      formTypeId: this.$config?.app?.forms?.ids?.CARD_REQUEST,
      selectedCard: ''
    }
  },

  watch: {
    '$route.query.form' (val) {
      if (!val) { this.selectedCard = '' }
    }
  },

  methods: {
    filterPropertiesList () {
      return this.fields?.mainFields?.filter((property: { code: string }) => property?.code?.includes('property'))
    },
    setFormSettings () {
      this.setGlobalFormProviderProperties({
        typeId: this.formTypeId,
        typeOfCard: this.selectedCard,
        productList: this.productList,
        isLong: this.$attrs?.['is-long'] || this.blockParams?.isLong
      })
    },
    openModal () {
      this.selectedCard = this.mainFields?.title?.value
      this.setFormSettings()
      this.$router.push({ query: { ...this.$route.query, form: this.formTypeId } })
    }
  }
})
